/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.playback.getLiveSegment";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"streamer":/*#__PURE__*/ l.string(),"track":/*#__PURE__*/ l.string(),"seg":/*#__PURE__*/ l.string(),"sid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"token":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("video/mp4");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Fetch a single live HLS segment, or a track's init segment, from the in-memory live window. `seg` is `init` for the EXT-X-MAP init segment, otherwise the segment's media-sequence number; a cosmetic `.m4s` suffix is accepted (and ignored) so ffmpeg-based HLS players will fetch it. HTTP Range is honored. Segments are the verbatim signed canonical .m4s, so provenance travels with playback. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["StreamNotLive","SegmentNotFound"]);

export { main };

export const $lxm = $nsid;
